import { render, staticRenderFns } from "./Content.vue?vue&type=template&id=2e5d3671&scoped=true"
import script from "./Content.vue?vue&type=script&lang=js"
export * from "./Content.vue?vue&type=script&lang=js"
import style0 from "./About.scss?vue&type=style&index=0&id=2e5d3671&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e5d3671",
  null
  
)

export default component.exports